export default {
	home: {
		afunOriginals: "AFunオリジナル",
		slots: "スロット",
		liveCasino: "ライブカジノ",
		casualGames: "カジュアルゲーム",
		newReleases: "新作",
		casinoTitle: "カジノ",
		casinoDesc: "数千のスロット、ライブディーラー、テーブルゲームでカジノゲームをお楽しみください",
		goToCasino: "カジノへ",
		sportsTitle: "スポーツ",
		sportsDesc: "サッカー、バスケットボール、テニスなど、最高のオッズでスポーツに賭けよう",
		goToSports: "スポーツへ",
		liveTitle: "ライブ",
		liveDesc: "ライブディーラーとインタラクティブなゲーム体験でリアルタイムアクション",
		goToLive: "ライブへ",
		latestBetRace: "最新のベット＆レース",
		sports: "スポーツ",
		latestBets: "最新のベット",
		game: "ゲーム",
		player: "プレイヤー",
		bet: "ベット",
		multiplier: "マルチプライヤー",
		profit: "利益",
		top10Games: "トップ10ゲーム",
		vipClub: "VIPクラブ",
		details: "詳細",
		progressToVip: "VIP{level}まで{percent}%",
		vipMax: "VIP最高",
		vipDetailsTitle: "VIPレベルと特典",
		vipColLevel: "レベル",
		vipColRequired: "必要条件",
		vipColLevelUpBonus: "昇格ボーナス",
		vipColDailyRakeback: "デイリーレーキバック",
		vipColWeeklyLossback: "ウィークリーロスバック",
		vipColMonthlyRakeback: "マンスリーレーキバック",
		vipRequiredRecharge: "入金",
		vipRequiredBets: "ベット",
		vip: "VIP",
		rewards: "特典",
		affiliate: "アフィリエイト",
		promotion: "プロモーション"
	},

	latestBetRace: {
		title: "ゲームリーダーボードグランプリ",
		playerBetRank: "本日のプレイヤーベット",
		playerWinRank: "本日のプレイヤー勝利",
		gameBetRank: "本日のゲームベット",
		gameWinRank: "本日のゲーム配当",
		player: "プレイヤー",
		game: "ゲーム",
		bet: "ベット",
		profit: "勝利",
		ratio: "配当倍率",
		totalBet: "総ベット額",
		totalReturn: "総配当額",
		maxBet: "最大ベット額",
		gameRatio: "還元率 %",
		noData: "データがありません"
	},

	GameClassify: {
		casinoTitle: "カジノ",
		casinoDesc: "トッププロバイダーのカジノゲームを楽しもう",
		casinoBtn: "カジノへ行く",
		sportsTitle: "スポーツ",
		sportsDesc: "サッカー、クリケット、NFL、eスポーツなど80種類以上のスポーツにベット",
		sportsBtn: "スポーツへ行く",
		liveTitle: "ライブ",
		liveDesc: "ライブディーラーとのリアルタイムな駆け引き",
		liveBtn: "ライブへ行く"
	}
}